import { SchemaType } from "@redotech/redo-flows-common/schemas/schemas";
import { recoverConfigSchema } from "@redotech/redo-marketing-templates-common/recover-config";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const createRecoverConfig = {
  name: "createRecoverConfig" as const,
  input: z.object({
    name: z.string(),
    schemaType: createEnum(SchemaType).optional(),
  }),
  output: recoverConfigSchema,
};
